import { State } from "@zyzgroup/core-common";
import {
  AppContext,
  VNode,
  createVNode,
  render,
  getCurrentInstance,
  VNodeProps,
  Component,
  // ComponentPublicInstance,
  ComponentInternalInstance,
  computed
} from "vue";

export function useMapState(state: State, keys: string[]) {
  const mapped: Record<string, ReturnType<typeof computed> | any> = {};
  keys.forEach((key: string) => {
    mapped[key] = computed(() => state[key]);
  });
  return mapped;
}

export function getInstance(): ComponentInternalInstance | null {
  return getCurrentInstance();
}

export interface CommonComponentProps extends VNodeProps {
  [index: string]: any;
}

export function getVNode<T extends Component>(
  component: T,
  props?: CommonComponentProps
): VNode {
  const vNode = createVNode(component, props);
  // const vm: ComponentPublicInstance<CommonComponentProps> | null | undefined =
  //   vNode.component?.proxy;
  // if (vm) {
  //   for (const prop in props) {
  //     if (Reflect.has(props, prop) && !Reflect.has(vm.$props, prop)) {
  //       vm[prop as keyof ComponentPublicInstance] = props[prop];
  //     }
  //   }
  // }
  return vNode;
}

export function renderComponent<T extends Component>(options: {
  component: T;
  props?: CommonComponentProps;
  appContext?: AppContext;
  selfContainer: HTMLElement;
  parentContainer?: HTMLElement;
}) {
  const vNode = getVNode(options.component, options.props);
  if (options.appContext) {
    vNode.appContext = options.appContext;
  }
  render(vNode, options.selfContainer);
  options.parentContainer?.appendChild(options.selfContainer);
}

// export interface EnhancedComponentOptions extends VNodeProps {
//   [key: string]: any;
// }
// export function enhanceComponent<T extends Component>(
//   component: T
// ): (options: EnhancedComponentOptions) => VNode {
//   const container = document.createElement("div");
//   return (options: EnhancedComponentOptions): VNode => {
//     const vNode = renderComponent<T>({
//       Component: component,
//       props: options,
//       selfContainer: container,
//       appContext: getCurrentInstance()?.appContext
//     });
//     const vm = vNode.component
//       ?.proxy as ComponentPublicInstance<EnhancedComponentOptions>;
//     for (const prop in options) {
//       if (Reflect.has(options, prop) && !Reflect.has(vm.$props, prop)) {
//         vm[prop as keyof ComponentPublicInstance] = options[prop];
//       }
//     }
//     return vNode;
//   };
// }
